import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconGroup = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconGroup",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M40-272q0-34 18-62t46-44q62-31 126-46t130-16 130 16 126 46q29 15 47 44t17 62v32q0 33-23 57t-57 23H120q-33 0-56-23t-24-57zm698 112q11-18 17-38t5-42v-40q0-44-24-84t-70-70q51 6 96 21t84 35q36 20 55 45t19 53v40q0 33-23 57t-57 23zM360-480q-66 0-113-47t-47-113 47-113 113-47 113 47 47 113-47 113-113 47m400-160q0 66-47 113t-113 47l-28-2q-17-2-28-6 27-32 42-71t14-81-14-81-42-71q14-5 28-6t28-2q66 0 113 47t47 113"
  })
}));